import { Fragment, useContext, useEffect, useRef, useState } from "react";
import { GlobalContext } from "../../Context/GlobalContext";
import Skeleton from "react-loading-skeleton";
import { NoteMessageContainer } from "../../Layout/Common/alert/noteMessageContainer";
import {
  addressLine1Keys,
  addressToKeys,
  billAddressLine1Keys,
  billAddressToKeys,
  billContactLineKeys,
  BILLINFO_SHIPMETHOD,
  cardTypeIcon,
  contactLineKeys,
  NOTEMESSAGE,
  PAYMENT_GATEWAY,
  PAYMENT_METHOD_STRING,
} from "../../constants";
import {
  formatAddress,
  normalizePath,
  normalizeUrlPath,
  scrollToFocuse,
  StringToObject,
} from "../../Layout/Common/common";
import { StorePickupAddress } from "./storePickupAddress";
import { ShippingAddress } from "./shippingAddress";
import { StorePickupAddressTop } from "./storePickupAddressTop";
import { OrderTrackingContainer } from "./orderTrackingContainer";
import { useLocation } from "react-router-dom";
import { CardIcon } from "../../Layout/Common/CardIcon";

export const OrderDetailMain = ({ billInfo, payonline = false }) => {
  const { shippingAddress, billingAddress, setCartItem } = useContext(GlobalContext);
  const { SUMMARYCOURIERPICKUP, SUMMARYSUBMITORDER } = NOTEMESSAGE;
  const [billAddress, setBillAddress] = useState(null);
  const [shipAddress, setShipAddress] = useState(null);
  const [shipMethod, setShipMethod] = useState(null);
  const [cardType, setCardType] = useState(null);
  const [cardNumber, setCardNumber] = useState(null);
  const [orderStatus, setOrderStatus] = useState(null);
  const location = useLocation();
  const paymentData = location.state;
  useEffect(() => {
    if (billInfo) {
      if (billInfo.deliveryAddress) setBillAddress(billInfo.deliveryAddress);
      if (billInfo.shippingAddress) setShipAddress(billInfo.shippingAddress);
      if (billInfo.shipMethod)
        setShipMethod(BILLINFO_SHIPMETHOD[StringToObject(billInfo.shipMethod)] || billInfo.shipMethod);

      if (billInfo.orderStatus) setOrderStatus(billInfo.orderStatus);
      if (billInfo.cardType && billInfo.cardNumber) {
        setCardType(billInfo.cardType);
        setCardNumber(billInfo.cardNumber);
      }
    }
  }, [billInfo]);

  useEffect(() => {
    if (paymentData) {
      if (paymentData.cardType) setCardType(paymentData.cardType);
      if (paymentData.cardNumber) setCardNumber(paymentData.cardNumber);
      if (paymentData.status) setOrderStatus(paymentData.status);
      if (paymentData.type == "PAYONLINE") setCartItem(null);
    }
  }, [paymentData]);

  return (
    <Fragment>
      {billInfo && shipMethod && shipMethod == BILLINFO_SHIPMETHOD["COUNTERPICKUP"] && <StorePickupAddressTop />}
      {billInfo && billInfo.trackInfo && <OrderTrackingContainer trackingInfo={billInfo.trackInfo} />}
      <div className="col-lg-12">
        {billInfo && (
          <div className="summited-order-details">
            <h2>Order Details</h2>
            <div className="cc-summited-order orderComplete-submit">
              <div className="row">
                {!payonline && (
                  <div className="col-sm-6 col-md-12 col-lg-6">
                    <div className="placed-order-details">
                      <div className="cc-placed-order">
                        <p>Contact information</p>
                        <div className="placed-order-info" style={{ textTransform: "capitalize" }}>
                          {shipAddress ? (
                            formatAddress(shipAddress, contactLineKeys).join(", ")
                          ) : (
                            <Skeleton width={150} />
                          )}
                        </div>
                      </div>
                    </div>
                  </div>
                )}
                <div className="col-sm-6 col-md-12 col-lg-6">
                  <div className="placed-order-details">
                    <div className="cc-placed-order">
                      <p>Order Status</p>
                      <div className="placed-order-info">
                        {billInfo.isTBA ? "TBA" : <Fragment>{orderStatus}</Fragment>}
                      </div>
                    </div>
                  </div>
                </div>
                <div className="col-sm-6 col-md-12 col-lg-6">
                  <div className="placed-order-details">
                    <div className="cc-placed-order">
                      <p>Shipping Method</p>
                      <div className="placed-order-info">{shipMethod || <Skeleton width={100} />}</div>
                    </div>
                  </div>
                </div>
                {!payonline && (
                  <div className="col-sm-6 col-md-12 col-lg-6">
                    {billInfo.isTBA == false && (
                      <div className="placed-order-details">
                        <div className="cc-placed-order">
                          <p>Payment Method</p>
                          {PAYMENT_GATEWAY.includes(billInfo.paymentMethod) ? (
                            <div className="placed-order-info">
                              <img src={cardTypeIcon[cardType] || cardTypeIcon["masterNot"]} alt="Card-details" />
                              {`  ${cardNumber}  $${billInfo.totalAmount.toFixed(2)}`}
                            </div>
                          ) : normalizePath(billInfo.paymentMethod) == "gp" ? (
                            <div className="placed-order-info d-flex align-items-center">
                              <CardIcon
                                cardType={"google-pay"}
                                style={{ maxHeight: "50px", marginLeft: "-10px" }}
                                alt={"Google Pay"}
                              />
                              {`$${billInfo.totalAmount.toFixed(2)}`}
                            </div>
                          ) : (
                            <div className="placed-order-info">
                              {`${PAYMENT_METHOD_STRING[billInfo.paymentMethod] || billInfo.paymentMethod} ${
                                billInfo.isTBA == false && ` $${billInfo.totalAmount.toFixed(2)}`
                              } `}
                            </div>
                          )}
                        </div>
                      </div>
                    )}
                  </div>
                )}
                {StringToObject(billInfo.shipMethod) == "COUNTERPICKUP" ? (
                  <StorePickupAddress />
                ) : (
                  <ShippingAddress shipAddress={shipAddress} />
                )}
                <div className="col-sm-6 col-md-12 col-lg-6">
                  <div className="placed-order-details">
                    <div className="cc-placed-order">
                      <p>Billing Address</p>
                      <div className="placed-order-info placed-orderAddress" style={{ textTransform: "capitalize" }}>
                        <address>
                          {billAddress ? formatAddress(billAddress, billAddressToKeys) : <Skeleton width={100} />}
                          <br />
                          {billAddress ? (
                            formatAddress(billAddress, billAddressLine1Keys).join(", ")
                          ) : (
                            <Skeleton width={150} />
                          )}
                          <br />
                          {billAddress ? billAddress.billCountry : <Skeleton width={150} />}
                          <br />
                          {billAddress ? (
                            formatAddress(billAddress, billContactLineKeys).join(", ")
                          ) : (
                            <Skeleton width={150} />
                          )}
                        </address>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        )}
      </div>
      {billInfo && shipMethod && shipMethod == BILLINFO_SHIPMETHOD["COURIERPICKUP"] && (
        <NoteMessageContainer heading={SUMMARYCOURIERPICKUP.title} contant={SUMMARYCOURIERPICKUP.content} />
      )}
    </Fragment>
  );
};
